import { IBanner } from '../types';

const PromotionsMiddleBanner = ({ title, image, redirect_url }: IBanner) => {
  return (
    <a rel="noreferrer" target="_blank" href={redirect_url}>
      <div className="tw-relative tw-w-full tw-transition-transform hover:tw-cursor-pointer hover:[transform:translateY(-10px)] min-[576px]:tw-mx-auto min-[576px]:tw-w-fit min-[1170px]:tw-mx-0">
        <img src={image} alt={title} className="tw-w-full" />
        <h4 className="tw-absolute tw-inset-x-5 tw-bottom-5 tw-text-xl tw-font-semibold tw-text-white md:tw-text-2xl">
          {title}
        </h4>
      </div>
    </a>
  );
};

export default PromotionsMiddleBanner;
